"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SONY = [
    { deviceName: 'Sony Xperia XZ', brandName: 'Sony', deviceCode: 'SOV34' },
    { deviceName: 'Sony Xperia L1 Dual', brandName: 'Sony', deviceCode: 'G3312' }
];
//# sourceMappingURL=sony.js.map